import React, { Component, ChangeEvent } from "react";
import Keyboard from "react-simple-keyboard";


import "react-simple-keyboard/build/css/index.css";


import { withStyles, Theme, WithStyles } from '@material-ui/core/styles';


import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { AppState, IPageState } from "appredux";
import { Button, TextField } from "@material-ui/core";
import { connect } from "react-redux";
import { capitalizeFirstLetter } from "./helpers";

interface KlawiaturaProps {
    page: IPageState,

    randomNum: number,
    val: string,
    onConfirm: (val: string) => void,
    placeholder: string,
    type: "default" | "number",
    uppercase: boolean

    
   }
   
   interface KlawiaturaState {
    open: boolean,
    layoutName: string,
    input: string,
    settedRef: boolean,
     
   }

   

class Klawiatura extends React.Component<WithTranslation & WithStyles<typeof styles> & KlawiaturaProps, KlawiaturaState> {
  keyboardRef: React.RefObject<HTMLInputElement>;
    constructor(props: WithTranslation & WithStyles<typeof styles> & KlawiaturaProps ) {
        super(props, {});

        this.state = {
           open: true,
           layoutName: this.props.uppercase ? "shift" : "default",
           input: this.props.val,
           settedRef: false
            
        }
        this.keyboardRef = React.createRef<HTMLInputElement>();
    }
    
    

      componentDidUpdate(prevProps: KlawiaturaProps, prevState: KlawiaturaState) {
        //if(this.props.page.openKlawiatura !== prevProps.page.openKlawiatura){
        //    this.setState({open: true})
        //}
        if(this.props.randomNum !== prevProps.randomNum){
            this.setState({open: true, input: this.props.val, settedRef: false, layoutName: this.props.uppercase ? "shift" : "default",})
            
        }
    }

    closeDialogOK = () => {
        this.setState({open: false})
        this.props.onConfirm(this.state.input)
    }

    closeDialog = () => {
      this.setState({open: false})
  }

    
      onChange = (input: string) => { 
        //console.log(this.state.input);
        //console.log(input);
        if(input.length === 1 && this.state.input.length !== 0 && !this.state.settedRef){ //input.length === 1 && this.state.input.length > 2
          this.setState({ input: this.state.input + input, settedRef: true });
          this.keyboardRef.setInput(this.state.input);
        } else {
          this.setState({ input: input });
        }
        
        //console.log("Input changed", input);
      };
    
      onKeyPress = (button: any) => {
        //console.log("Button pressed", button);
        //console.log(this.keyboardRef)
        //console.log(this.keyboardRef.input.default)

        if(button === "{bksp}" && this.keyboardRef.input.default !== this.state.input){ 
          this.keyboardRef.setInput(this.state.input);
          let inp = this.state.input.slice(0, -1); 
          this.setState({ input: inp });
        }
        /**
         * If you want to handle the shift and caps lock buttons
         */
        if (button === "{shift}" || button === "{lock}") this.handleShift();
      };
    
      handleShift = () => {
        const layoutName = this.state.layoutName;
    
        this.setState({
          layoutName: layoutName === "default" ? "shift" : "default"
        });
      };
    
      onChangeInput = (event: ChangeEvent<HTMLInputElement>): void => {
        const input = event.target.value;
        this.setState({ input: input });
        this.keyboardRef.setInput(input);
      };

      setLayout = () => {
        let lay
        switch (this.props.type) {
          case "number":
            lay = {
              default: ["1 2 3", "4 5 6", "7 8 9", "{bksp} 0 {bksp}"], //"+ 0 _" //{shift}
              shift: ["! / #", "$ % ^", "& * (", "{shift} ) +", "{bksp}"]
            }
            break;
          case "default":
            lay = undefined

            break;
        }
        return lay
      }

      setDisplay = () => {
        let dis
        switch (this.props.type) {
          case "number":
            dis = {
              "{backspace}": "⌫",
              "{bksp}": "⌫",
            }
            break;
          case "default":
            dis = undefined

            break;
        }
        return dis
      }


     
   
  render() {
    const {classes, t} = this.props;
    //console.log(this.keyboardRef)

    let lay = this.setLayout()

    //if(this.keyboardRef){
    //  this.keyboardRef.setInput(this.props.val);
    //}
    

    return (
        <>
        <Dialog
                maxWidth="sm"
                open={this.state.open}
                //onClose={this.closeDialog}
                disableBackdropClick
                fullWidth
            >
                <DialogTitle disableTypography>
                    <Typography gutterBottom variant="h5" component="h2" color="primary" style={{ fontSize: "1.25rem", textTransform: "lowercase" }}>
                        <b>{t("wpisz") + " " + this.props.placeholder}</b>
                        {/* <b><Trans>Confirmation</Trans></b> */}
                    </Typography>
                    <hr />
                </DialogTitle>
            <DialogContent>
        <div>

              <TextField
                 value={this.state.input}
                 placeholder={capitalizeFirstLetter(this.props.placeholder)} //{"Tap on the virtual keyboard to start"}
                 onChange={this.onChangeInput}
                 className={classes.input0}

               
                
                //className={classes.floatLeft}
                //style={{ width: '85%' }}
                variant="outlined"
                inputProps={{ style: { backgroundColor: this.state.input ? this.props.page.secondaryLight : '#ffffff' } }}
                InputProps={{ classes: { input: `${classes.primary} ${classes.input1}` } }}
               

              />


        {/* <input
          value={this.state.input}
          placeholder={this.props.placeholder} //{"Tap on the virtual keyboard to start"}
          onChange={this.onChangeInput}
          className={classes.input}
        /> */}
        <Keyboard
          keyboardRef={r => (this.keyboardRef = r)}
          //keyboardRef={this.keyboardRef}
          layoutName={this.state.layoutName}
          layout={lay}
          display={this.setDisplay()}
           
          onChange={this.onChange}
          onKeyPress={this.onKeyPress}
        />
      </div>
      </DialogContent>
            <DialogActions>
            <Button variant="outlined" color="primary" size="small"
                    onClick={this.closeDialog}>
              <b><Trans>Back</Trans></b>
            </Button>     
            <Button variant="contained" color="primary" size="small"
                    onClick={this.closeDialogOK}>
              <b>OK</b>
            </Button>      
          </DialogActions>
        </Dialog>
        </>
    );
  }
}




const styles = (theme: Theme) => ({
    input: {
        width: "100%",
        height: "100px",
        padding: "20px",
        fontSize: "20px",
        border: "none",
        boxSizing: "border-box" as "border-box",
      },
      input0: {
        width: "100%",
        //height: "100px",
        //padding: "20px",
        fontSize: "20px",
        //border: "none",
        //boxSizing: "border-box" as "border-box",
        marginBottom: "20px"
      },

      primary: {
        color: theme.palette.primary.main
    },

      black: {
        color: "rgb(0, 0, 0)"
    },
    input1: {
        padding: "12px 11px",
        fontWeight: 'normal' as 'normal',
        textAlign: 'left' as 'left',
        fontSize: "20px",
        //width: "100%",
        //marginBottom: "12px"
    },
});


const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
  });
  
  export default withStyles(styles)(connect(mapStateToProps)(withTranslation()(Klawiatura)));